import React from "react";
import PropTypes from "prop-types";
import { Link } from "@mui/material/";

type Props = {
    data: Object,
    clsName: string,
};
const LinkLocation = ({ data, clsName }: Props) => {
    const mapsSelector = (location: any) => {
        const { address, latitude, longitude, name } = location;
        let label = "";
        let latLng = "";
        let url = "";
        label = `${name}`;
        if (address) label += `, ${address}`;
        if (latitude && longitude) latLng = `${latitude},${longitude}`;

        if (
            (navigator.userAgent.match(/Android/i) ||
                navigator.userAgent.match(/iPhone/i)) &&
            latLng !== ""
        )
            url = `maps://www.google.com/maps?daddr=${latLng}&amp;ll=`;
        else url = `https://www.google.com/maps/search/${label}/@${latLng}`;
        window.open(url);
    };

    return data && data.length > 0
        ? data.map((item, idx) => (
              <Link
                  component="a"
                  className={clsName}
                  rel="noopener noreferrer"
                  key={`${item.name}_${idx}`}
                  onClick={(evt) => {
                      mapsSelector(item);
                  }}
              >
                  {item.name}
              </Link>
          ))
        : null;
};

export default LinkLocation;
